// TR
export const locale = {
  lang: 'tr',
  data: {
    TRANSLATOR: {
      SELECT: 'Dilinizi seçin',
    },
    MENU: {
      NEW: 'yeni',
      ACTIONS: 'Hareketler',
      CREATE_POST: 'Yeni Gönderi Oluştur',
      PAGES: 'Sayfalar',
      FEATURES: 'Özellikler',
      APPS: 'Uygulamalar',
      DASHBOARD: 'Kontrol Paneli',
      DATAHISTORY: 'Geçmiş Emisyon Verisi',
      SUPPLIERS: 'Tedarikçiler',
    },
    AUTH: {
      GENERAL: {
        OR: 'Veya',
        SUBMIT_BUTTON: 'Gönder',
        NO_ACCOUNT: 'Hesabınız yok mu?',
        SIGNUP_BUTTON: 'Üye Ol',
        FORGOT_BUTTON: 'Şifremi Unuttum',
        BACK_BUTTON: 'Geri',
        PRIVACY: 'Gizlilik',
        LEGAL: 'Yasal',
        CONTACT: 'İletişim',
        PLEASE_WAIT: 'Lütfen bekleyin...',
        POWERED_BY: 'Powered by Carbon Gate',
      },
      LOGIN: {
        TITLE: 'Hesaba Giriş Yap',
        BUTTON: 'Giriş Yap',
      },
      FORGOT: {
        TITLE: 'Şifrenizi mi unuttunuz?',
        DESC: 'Şifrenizi sıfırlamak için e-postanızı girin',
        SUCCESS: 'Hesabınızın şifresi başarıyla sıfırlandı.',
        SEND_BUTTON: 'Gönder',
        SENT_INFO:
          'Şifre sıfırlama isteği gönderildi. Lütfen e-postanızı kontrol edin.',
      },
      FORGOT_PASSWORD_SUCCESS: {
        TITLE: 'Şifremi Unuttum',
        INFO: 'Şifre kurtarma bağlantısı e-posta adresinize gönderildi.',
        LOGIN_HINT: 'Lütfen şifrenizi sıfırladıktan sonra giriş yapın.',
        LOGIN_BUTTON: 'Giriş Yap',
      },
      CONFIRM_EMAIL: {
        TITLE: 'Hesabı Onayla',
        LOADING: 'Hesabınız onaylanıyor, lütfen bekleyin...',
        SUCCESS: 'Hesabınız başarıyla onaylandı.',
      },
      CREATE_PASSWORD: {
        TITLE: 'Şifre Oluştur',
        NEW_PASSWORD: 'Yeni Şifre',
        CONFIRM_PASSWORD: 'Şifreyi Onayla',
        BUTTON: 'Şifre Oluştur',
        STRONG_PASSWORD_HINT:
          'Şifre en az 8 karakter olmalı ve büyük harf, küçük harf, rakam, özel karakter içermelidir.',
      },
      REGISTER: {
        TITLE: 'Kayıt Ol',
        DESC: 'Hesabınızı oluşturmak için bilgilerinizi girin',
        SUCCESS: 'Hesabınız başarıyla kaydedildi.',
      },
      INPUT: {
        EMAIL: 'E-Posta',
        FULLNAME: 'Ad Soyad',
        PASSWORD: 'Şifre',
        CONFIRM_PASSWORD: 'Şifreyi Onayla',
        USERNAME: 'Kullanıcı Adı',
        USERNAME_OR_EMAIL: 'Kullanıcı Adı veya E-Posta',
        SELECT_TENANT: 'Kurum Seçiniz',
      },
      VALIDATION: {
        INVALID: '{{name}} geçerli değil',
        REQUIRED: '{{name}} gereklidir',
        MIN_LENGTH: '{{name}} minimum uzunluk {{min}} olmalıdır',
        AGREEMENT_REQUIRED: 'Şartlar ve koşulların kabul edilmesi gereklidir',
        NOT_FOUND: 'İstenen {{name}} bulunamadı',
        INVALID_LOGIN: 'Giriş detayı doğru değil',
        REQUIRED_FIELD: 'Gerekli alan',
        MIN_LENGTH_FIELD: 'Minimum alan uzunluğu:',
        MAX_LENGTH_FIELD: 'Maksimum alan uzunluğu:',
        INVALID_FIELD: 'Alan geçerli değil',
      },
      MESSAGES: {
        INVALID_EMAIL: 'Lütfen geçerli bir e-posta girin.',
        INVALID_USERNAME_OR_EMAIL: 'Lütfen kullanıcı adınızı veya e-postanızı girin.',
        INVALID_TENANT: 'Lütfen bir kurum seçiniz.',
        INVALID_PASSWORD: 'Hatalı ya da eksik şifre girdiniz.',
        INVALID_CREDENTIALS: 'E-posta veya şifre hatalı.',
        SESSION_CHANGED:
          'Oturum bilgileriniz başka bir sekmede değişti. Lütfen tekrar giriş yapın.',
        PASSWORD_RESET_SUCCESS: 'Şifreniz başarıyla değiştirildi.',
        PASSWORD_CREATED_SUCCESS: 'Yeni şifreniz başarıyla oluşturuldu.',
        GENERIC_ERROR:
          'Üzgünüz, bazı hatalar tespit edildi, lütfen tekrar deneyin.',
      },
      OTP: {
        TITLE: 'İki Adımlı Doğrulama',
        SUBTITLE: 'E-posta adresinize gönderilen doğrulama kodunu girin.',
        CODE_LABEL: 'Doğrulama kodu',
        CODE_FORMAT: 'Kod yalnızca rakamlardan oluşmalıdır.',
        VERIFY: 'Doğrula',
        RESEND: 'Kodu tekrar gönder',
        RESEND_IN: 'Tekrar gönderim {{seconds}} sn sonra',
        BACK_TO_LOGIN: 'Girişe dön',
        INVALID_CODE: 'Doğrulama kodu geçersiz veya süresi dolmuş.',
        SESSION_EXPIRED:
          'Doğrulama oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
        TOO_MANY_REQUESTS:
          'Çok fazla deneme yapıldı. Lütfen bekleyip tekrar deneyin.',
        SENT: 'Yeni doğrulama kodu gönderildi.',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Seçilen kayıtların sayısı: ',
        ALL: 'Hepsi',
        SUSPENDED: 'Ertelenmiş',
        ACTIVE: 'Aktif',
        FILTER: 'Filtre',
        BY_STATUS: 'Duruma Göre',
        BY_TYPE: 'Türe Göre',
        BUSINESS: 'İşletme',
        INDIVIDUAL: 'Bireysel',
        SEARCH: 'Ara',
        IN_ALL_FIELDS: 'Tüm alanlarda',
      },
      ECOMMERCE: 'e-Ticaret',
      CUSTOMERS: {
        CUSTOMERS: 'Müteriler',
        CUSTOMERS_LIST: 'Müşteri Listesi',
        NEW_CUSTOMER: 'Yeni Müşteri',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Müşteri Silme',
          DESCRIPTION:
            'Bu müşteriyi kalıcı olarak silmek istediğinizden emin misiniz?',
          WAIT_DESCRIPTION: 'Müşteri siliniyor...',
          MESSAGE: 'Müşteri silindi',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Müşteri Silme',
          DESCRIPTION:
            'Bu müşterileri kalıcı olarak silmek istediğinizden emin misiniz?',
          WAIT_DESCRIPTION: 'Müşteriler siliniyor...',
          MESSAGE: 'Seçili müşteriler silindi',
        },
        UPDATE_STATUS: {
          TITLE: 'Seçilen müşteriler için durum güncellendi',
          MESSAGE: 'Seçilen müşterilerin durumu başarıyla güncellendi',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Müşteri güncellendi',
          ADD_MESSAGE: 'Müşteri oluşturuldu',
        },
      },
    },
  },
};
